/** Half-open [start, end) overlap, matching tstzrange(..., '[)'). */
export function rangesOverlapHalfOpen(
  start: Date,
  end: Date,
  otherStart: Date,
  otherEnd: Date,
): boolean {
  return start < otherEnd && end > otherStart;
}

export interface CalendarBlockOverlap {
  id: string;
  name: string;
  startsAt: Date;
  endsAt: Date;
}

export function overlappingCalendarBlocks(
  blocks: CalendarBlockOverlap[],
  start: Date,
  end: Date,
  excludeAppointmentId?: string | null,
): CalendarBlockOverlap[] {
  if (!(end > start)) return [];
  return blocks.filter((block) => {
    if (excludeAppointmentId && block.id === excludeAppointmentId) return false;
    return rangesOverlapHalfOpen(start, end, block.startsAt, block.endsAt);
  });
}

/** "Frokost 12:00–13:00" or several blocks joined for the warning sentence. */
export function calendarBlockOverlapLabel(
  overlaps: CalendarBlockOverlap[],
  formatClock: (date: Date) => string,
): string {
  return overlaps
    .map((block) => `${block.name} ${formatClock(block.startsAt)}–${formatClock(block.endsAt)}`)
    .join(', ');
}
